import * as React from "react";
import { useLocation } from "react-router-dom";
import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

interface Location {
  hash: string;
  key?: string;
  pathname: string;
  search: string;
  state: unknown;
}

interface LocationHistory {
  previous: Location[];
  current: Location;
}

const useRawZustandLocation = create<LocationHistory>(() => ({
  previous: [],
  current: {
    search: "",
    pathname: "",
    hash: "",
    state: null,
    key: "",
  },
}));

export const useLocationStore = <T>(
  selector: (state: LocationHistory) => T
): T => {
  return useRawZustandLocation(useShallow(selector));
};

export const LocationStoreProvider = () => {
  "use no memo";
  const location = useLocation();

  React.useEffect(() => {
    useRawZustandLocation.setState((state) => ({
      current: location,
      previous: [
        // only keep the last two locations
        ...state.previous.slice(-1),
        state.current,
      ].slice(-2),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location.search,
    location.pathname,
    location.key,
    location.hash,
    location.state,
  ]);

  return null;
};
